
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"80","height":"80","rx":"20","fill":"#000","fill-opacity":".5"}}),_c('path',{attrs:{"fill":"#fff","d":"M26 24h8v32h-8zM46 24h8v32h-8z"}})])
          )
        }
      }
    